import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
// import Container from '../components/Container';

const Home: React.FC = () => {
  const history = useHistory();
  const btnHandler = () => {
    // route to /app-academy
    history.push("/app-academy");
  }
  return (
    <IonPage className='home'>
      <IonContent fullscreen className='container'>
        <h1>School of Swipe™ có gì thú vị?</h1>
        <p style={{ lineHeight: '1.2' }}>Từ vuốt trái và phải, tương hợp, ghosting, đến thả thính và hơn thế nữa, mỗi bước đi trong hành trình hẹn hò là một bài học. Sẵn sàng dẫn đầu xu thế và nâng cấp các kỹ năng của bạn để chinh phục đối phương ngay thôi.<br />Bạn cần một khóa học hẹn hò? Bắt đầu lớp học ngay thôi.</p>
        <button className='white-btn' onClick={() => btnHandler()} style={{ zIndex: '105', marginTop: '1rem' }}>Cùng bắt đầu nào</button>
      </IonContent>
    </IonPage>
  );
};

export default Home;